import { MoneyEdit } from '@powerportalspro/react-fluent';

export function MoneyEditMainSample() {
  return <MoneyEdit columnName="ppp_annualincome" />;
}
